import { create } from "zustand";
import { createJSONStorage, persist, devtools } from "zustand/middleware";

export type AppState = {
    showMapOnLiveRoute: boolean;
    sidebarOpen: boolean;
    isLoading: boolean;
    setShowMapOnLiveRoute: (showMapOnLiveRoute: boolean) => void;
    toggleShowMapOnLiveRoute: () => void;
    setSidebarOpen: (sidebarOpen: boolean) => void;
    toggleSidebar: () => void;
    setLoading: (loading: boolean) => void;
};

const initialState = {
    sidebarOpen: true,
    showMapOnLiveRoute: false,
};

export const useAppState = create<AppState>()(
    persist(
        (set, get) => ({
            ...initialState,
            isLoading: true,
            setShowMapOnLiveRoute: (showMapOnLiveRoute: boolean) => set({ showMapOnLiveRoute }),
            toggleShowMapOnLiveRoute: () =>
                set((state) => ({ showMapOnLiveRoute: !state.showMapOnLiveRoute })),
            setSidebarOpen: (sidebarOpen: boolean) => set({ sidebarOpen }),
            toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
            setLoading: (isLoading: boolean) => set({ isLoading }),
        }),
        {
            name: "app",
            storage: createJSONStorage(() => sessionStorage),
            onRehydrateStorage: () => (state) => {
                state?.setLoading(false);
            },
        }
    )
);
